import React from "react";

const YogaBeginnersArticle = () => {
  return (
    <div style={{ background: '#f8fafb', minHeight: '100vh', padding: '10px 16px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <article style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)' }}>
          {/* Header Section */}
          <div style={{ background: 'linear-gradient(135deg, #7c8717 0%, #6b7a15 100%)', color: '#fff', padding: '12px 32px 10px 32px', textAlign: 'center', marginTop: '6px' }}>
            <h1 style={{ margin: '0 0 8px 0', fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.5px' }}>5 Simple Yoga Poses for Beginners</h1>
            <p style={{ margin: '0', fontSize: '0.98rem', opacity: 0.95, fontWeight: 400 }}>Build Flexibility and Reduce Stress</p>
          </div>

          {/* Content Section */}
          <div style={{ padding: '24px 32px 32px 32px' }}>
            <p style={{ fontSize: '1.05rem', lineHeight: 1.5, color: '#333', marginBottom: '28px', fontWeight: 425, backgroundColor: '#f0f9f0', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #7c8717' }}>
              Yoga is a gentle and effective way to improve flexibility, strength,
              balance, and mental well-being. If you're new to yoga, starting with
              simple poses helps you build confidence while reducing the risk of
              injury. Here are five beginner-friendly yoga poses you can practice at
              home.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#7c8717', marginTop: '36px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e8f0e8' }}>1. Mountain Pose (Tadasana)</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '12px' }}>
              Mountain Pose is the foundation of all standing yoga poses. It helps
              improve posture, balance, and body awareness.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '6px' }}>Stand tall with feet together</li>
              <li style={{ marginBottom: '6px' }}>Engage your core and relax your shoulders</li>
              <li style={{ marginBottom: '6px' }}>Breathe deeply for 5–10 breaths</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#7c8717', marginTop: '36px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e8f0e8' }}>2. Downward-Facing Dog (Adho Mukha Svanasana)</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '12px' }}>
              This pose stretches the entire body, especially the spine, hamstrings,
              and shoulders.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '6px' }}>Start on hands and knees</li>
              <li style={{ marginBottom: '6px' }}>Lift hips upward, forming an inverted "V"</li>
              <li style={{ marginBottom: '6px' }}>Hold for 5–8 breaths</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#7c8717', marginTop: '36px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e8f0e8' }}>3. Child's Pose (Balasana)</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '12px' }}>
              Child's Pose is a restful posture that calms the mind and gently
              stretches the lower back and hips.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '6px' }}>Kneel on the mat and sit back on your heels</li>
              <li style={{ marginBottom: '6px' }}>Stretch arms forward or rest them by your side</li>
              <li style={{ marginBottom: '6px' }}>Relax and breathe deeply</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#7c8717', marginTop: '36px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e8f0e8' }}>4. Tree Pose (Vrikshasana)</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '12px' }}>
              Tree Pose improves balance and concentration while strengthening the
              legs.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '6px' }}>Stand on one leg</li>
              <li style={{ marginBottom: '6px' }}>Place the other foot on the inner calf or thigh</li>
              <li style={{ marginBottom: '6px' }}>Bring palms together and hold for 5 breaths</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#7c8717', marginTop: '36px', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #e8f0e8' }}>5. Seated Forward Bend (Paschimottanasana)</h2>
            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '12px' }}>
              This seated pose stretches the spine and hamstrings while promoting
              relaxation.
            </p>
            <ul style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '6px' }}>Sit with legs extended</li>
              <li style={{ marginBottom: '6px' }}>Hinge forward from the hips</li>
              <li style={{ marginBottom: '6px' }}>Hold gently without forcing the stretch</li>
            </ul>

            <p style={{ fontSize: '1.0rem', lineHeight: 1.8, color: '#555', marginBottom: '28px', backgroundColor: '#f0f9f0', padding: '20px 24px', borderRadius: '8px', borderLeft: '4px solid #7c8717' }}>
              Practicing these simple yoga poses regularly can help build a strong
              foundation for your yoga journey. Move slowly, listen to your body,
              and enjoy the process.
            </p>

            {/* Byline */}
            <div style={{ borderTop: '1px solid #e8f0e8', paddingTop: '20px', marginTop: '32px' }}>
              <p style={{ fontSize: '0.95rem', color: '#888', fontStyle: 'italic', margin: '0' }}>
                Article by <strong>Mangalorehub.com Lifestyle Correspondent</strong>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default YogaBeginnersArticle;
